<template>
  <div class="equipWarning">
    <div class="warningList">
      <div
        v-for="(warning, index) in equipWarning"
        :key="index"
        class="list-cont"
      >
        <div class="warning-icon">
          <span
            class="type-icon"
            :style="{ backgroundImage: `url(${typeList[warning.key]})` }"
          ></span>
        </div>
        <div class="warning-main">
          <div class="main-head">
            <div class="warning-type">
              {{ warning.type }}
            </div>
            <div class="warning-time">
              {{ warning.time }}
            </div>
          </div>
          <div class="warning-cont">
            {{ warning.cont }}
          </div>
        </div>
      </div>
    </div>
    <div class="warning-detail">
      <span class="detail cursor-pointer" @click="toDetails">{{
        $t("View Details")
      }}</span>
      <span class="d-icon cursor-pointer"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    typeList() {
      return {
        remind: require("@/assets/vsd420/remind.svg"),
        error: require("@/assets/vsd420/error.svg"),
        warning: require("@/assets/vsd420/warning.svg")
      };
    },
    equipWarning() {
      return [
        {
          type: this.$t("Hint"),
          key: "remind",
          time: "2022-06-14  18:25:49",
          cont: this.$t("Motor current abnormal")
        },
        {
          type: this.$t("Error"),
          key: "error",
          time: "2022-06-14  18:25:49",
          cont: this.$t("Motor pump overheating")
        },
        {
          type: this.$t("Warning"),
          key: "warning",
          time: "2022-06-14  18:25:49",
          cont: this.$t("Motor vibration abnormal")
        },
        {
          type: this.$t("Notice"),
          key: "remind",
          time: "2022-06-14  18:25:49",
          cont: this.$t(
            "Cooling water flow of the pump is not less than the minimum flow"
          )
        }
      ];
    }
  },
  mounted() {},
  methods: {
    toDetails() {
      var routeData = this.$router.resolve({
        path: "/EventAlarm",
        query: { id: 1 }
      });
      window.open(routeData.href, "_blank");
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../../../../assets/scss/common.scss");
.equipWarning {
  height: 100%;
  display: flex;
  flex-flow: column;

  .warningList {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    .list-cont {
      display: flex;
      flex: 1;
      margin: 8px 0;
      font-size: 15px;
    }
    .warning-icon {
      .type-icon {
        display: inline-block;
        margin-top: 3px;
        margin-right: 10px;
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .warning-main {
      flex: 1;
      .main-head {
        display: flex;
        align-items: center;
        .warning-type {
          flex: 1;
        }
        .warning-time {
          flex: 2;
          text-align: right;
          padding-right: 5px;
        }
      }
      .warning-cont {
        margin-top: 5px;
      }
    }
  }
  .warning-detail {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 8px 0;
    color: #00e7ff;
    font-size: 12px;

    .d-icon {
      width: 20px;
      height: 20px;
      background: url("../../../../../assets/arrow.svg") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
